import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  addHtmlRootEventListener, appendHtmlElementChild, CURRENCY_EURO,
  getHtmlElement, parseAmount, removeHtmlElementClass,
  renderWebComponent, setHtmlElementContent,
  checkDeferredPayment
} from "../../../utils/utils";
import commonStyles from '../../styles/web-components.common.css';
import styles from '../../styles/modal.css'
import { EventBusComponent } from "../EventBusComponent";
import I18n from 'i18n.js.erb';

let root = null;

export class SubmissionListDeferredPaymentModalComponent extends HTMLElement {

  eventBus = null;
  modal = null;
  static instance = null;

  static getInstance(parentRoot, submissionList, paymentMethod, currentUserGenerality) {
    if (!SubmissionListDeferredPaymentModalComponent.instance) {
      SubmissionListDeferredPaymentModalComponent.instance = new SubmissionListDeferredPaymentModalComponent({ submissionList: submissionList, payment_method: paymentMethod, currentUserGenerality: currentUserGenerality });
      appendHtmlElementChild(parentRoot, SubmissionListDeferredPaymentModalComponent.instance);
    }
    addHtmlElementClass(root, 'deferredPaymentModal', 'show');
    return SubmissionListDeferredPaymentModalComponent.instance;
  }


  constructor(props) {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
    this.props = props;
    root = this.shadowRoot;
    this.render();
  }

  connectedCallback() {
    addHtmlElementEventListener(root, 'closeButton', 'click', () => this.handleCloseModal());
    addHtmlRootEventListener(window, 'keydown', (e) => e.key === 'Escape' ? this.handleCloseModal() : {});
    // window.top.document.addEventListener("click", function(e) {
    //   if (!modal.contains(e.target)) {
    //     this.handleCloseModal();
    //   }
    // });
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => {
      this.updateSubmissionListState(submissionList);
    });
    addHtmlElementEventListener(this.shadowRoot, 'confirm_btn', 'click', () => this.handleConfirmSubmissionList())
  }


  // Funzione che gestisce la chiusura della modale del pagamento differito dell'ordine
  handleCloseModal() {
    removeHtmlElementClass(root, 'deferredPaymentModal', 'show');
    this.eventBus.publish("cancelled-submission-list-checkout", this.props.submissionList);
  }


  // Funzione che gestisce la conferma finale della submission list
  // una volta che il pagamento tramite bonifico bancario è stato confermato dall'utente
  handleConfirmSubmissionList() {
    const url = `/submission_lists/${this.props.submissionList.id}`;

    const body = {};
    if (this.props.payment_method === 'bank_transfer') {
      body['state'] = 'pending_payment';
      body['payment_method'] = this.props.payment_method;
      body['bank_transfer_time_threshold'] = this.props.submissionList.grader_company.bank_transfer_time_range;
    } else if (this.props.payment_method === 'deferred_payment') {
      body['state'] = 'confirmed';
      body['payment_method'] = this.props.submissionList.payment_terms;
      body['deferred_payment_carried_out'] = false;
    }

    fetch(url + ".json", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body)
    })
      .then((response) => {
        if (!response.ok)
          throw Error("An error occour during saving data on the database");
        else
          return response.json();
      })
      .then((submissionList) => {
        getHtmlElement(root, 'deferredPaymentModal').classList.remove("show");
        this.eventBus.publish('closed-submission-list', submissionList);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        this.eventBus.publish('render-modal', {error: true});
      });
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState (submissionList) {
    this.props.submissionList = { ...submissionList};
    setHtmlElementContent(this.shadowRoot, 'bank_transfer_time_range', this.props.submissionList.grader_company.bank_transfer_time_range)
    setHtmlElementContent(this.shadowRoot, 'iban', this.props.submissionList.grader_company.iban);
    setHtmlElementContent(this.shadowRoot, 'bank_account_holder', this.props.submissionList.grader_company.bank_account_holder);
    setHtmlElementContent(this.shadowRoot, 'bic_swift_code', this.props.submissionList.grader_company.bic_swift_code);
    setHtmlElementContent(this.shadowRoot, 'submission_list_number', this.props.submissionList.number);
    setHtmlElementContent(this.shadowRoot, 'customer_amount', parseAmount(this.props.submissionList.customer_amount, 2));
    setHtmlElementContent(this.shadowRoot, 'deferred_time_delay', this.parseDeferredTimeDelay());
  }


  // Funzione che parsa il numero di giorni entro i quali un AIG Point ha la possibilità di effettuare il pagamento
  // differito dell'ordine a partire dalla data di emissione della fattura di pagamento
  parseDeferredTimeDelay() {
    if (checkDeferredPayment(this.props.submissionList.payment_terms))
      return this.props.submissionList.payment_terms.split('_')[0];
    else return '';
  }


  render() {
    const html = `      
      <div class="modal fade" id="deferredPaymentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" id="modalContainer">
          <div class="modal-content">
            <div class="modal-body" id="body">
              <div class="row pl-3">
                <div class="col-12 text-left pl-0">
                  ${ 
                    this.props.payment_method === 'bank_transfer' ?
                      `<p>
                        ${I18n.t('js.common.hello')} ${this.props.currentUserGenerality},
                      </p>
                      <p>
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.text1')}&nbsp;
                        <span id="bank_transfer_time_range">${this.props.submissionList.grader_company.bank_transfer_time_range}</span>&nbsp;
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.text2')}. 
                      </p>
                      <p class="mt-4">
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.text3')}: 
                      </p>
                      <h6 class="mt-4">
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.iban')}:&nbsp;
                        <span id="iban">${this.props.submissionList.grader_company.iban}</span>
                      </h6>
                      <h6>
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.bank_account_holder')}:&nbsp;
                        <span id="bank_account_holder">${this.props.submissionList.grader_company.bank_account_holder}</span>
                      </h6>
                      <h6>
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.bic_swift_code')}:&nbsp;
                        <span id="bic_swift_code">${this.props.submissionList.grader_company.bic_swift_code}</span>
                      </h6>
                      <h6>
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.causal')}:&nbsp;
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.order_payment')}&nbsp;
                        #<span id="submission_list_number">${this.props.submissionList.number}</span>
                      </h6>
                      <h6>
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.amount')}:&nbsp;
                        <span id="customer_amount">${parseAmount(this.props.submissionList.customer_amount, 2)}</span>${CURRENCY_EURO} 
                      </h6>
                      <p class="mt-4">
                        ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.text6').replaceAll(':grader_company', this.props.submissionList.grader_company.meta_name)}
                      </p>
                      `                 
                    :
                      this.props.payment_method === 'deferred_payment' ?
                        `<p>
                          ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.text4').replaceAll(':grader_company', this.props.submissionList.grader_company.meta_name)}
                        </p>
                        <p>
                          ${I18n.t('js.editSubmissionListPage.webComponent.deferred_payments.text5')}
                        </p>`
                      :
                        ``
                  }
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" 
                class="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized h-40px-imp"
                data-dismiss="modal" id="closeButton"
              >
                ${I18n.t('js.common.cancel').toUpperCase()}
              </button>
              
              <button type="button" 
                id="confirm_btn"
                class="btn-standard bg-aig-gradient color-white br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
              >
                ${I18n.t('js.common.confirm').toUpperCase()}
              </button>
            </div>
          </div>
        </div>
      </div>
    `

    renderWebComponent(html, root, [commonStyles, styles]);
    this.updateSubmissionListState(this.props.submissionList);
  }
}

window.customElements.define("submission-list-deferred-payment-modal-component", SubmissionListDeferredPaymentModalComponent);